import '../../../../styles/globals.css'
import { Box, Typography } from '@mui/material'
import karmaStyles from '../../../../styles/KarmaPool.module.css'
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useKarmaPoolContext } from '../../../../state/KarmaPoolContext';
import { Paper, Grid } from '@mui/material';

import PoolDonationImage from '../../../../images/note_graphics/pool_donation.png';
import UsernameIconDisplay from './UsernameIconDisplay';
import GetYoutubeCode, { GetSpotifyCode } from './NoteUtils';
import LoveSectionComponent from './LoveSectionComponent';
import YoutubeNoteComponent from './types/YoutubeNoteComponent';
import NoteExpiryGridPiece from './NoteExpiryGridPiece';
import DeleteNoteSectionComponent from './DeleteNoteSectionComponent';

import SpotifyNoteComponent from './types/SpotifyNoteComponent';
import PlaylistFeatureNoteComponent from './types/PlaylistFeatureNoteComponent';
import ImageNoteComponent from './types/ImageNoteComponent';
import FlashNoteComponent from './types/FlashNoteComponent';

const ReactMarkdown = require('react-markdown').default;

function DonationNoteComponent(props) {

    return (
        <Box sx={{

        }}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
                <Grid container className='' spacing={0.5} sx={{
                    maxWidth: "21.55rem",
                    minWidth: "21.55rem",
                    width: "100.0%",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "0.5rem",
                    margin: "0.25rem",
                    backgroundColor: "rgba(221, 221, 221, 0.075)",
                    borderRadius: "0.25rem",
                    borderColor: "rgba(221, 221, 221, 0.25)",
                    border: "1px solid rgba(221, 221, 221, 0.35)"
                }}>
                    <Grid item xs={6} sm={6}>
                        <UsernameIconDisplay note={props.note} />
                    </Grid>
                    <DeleteNoteSectionComponent note={props.note} />
                    <LoveSectionComponent note={props.note} />
                    <Grid item xs={12} sm={12} sx={{ textAlign: "left", marginLeft: "1rem", marginTop: "0.45rem", marginBottom: "0.675rem" }}>
                        <Typography variant="body2" component="div" gutterBottom>
                            Karma Pool fulfilled a donation 💕
                        </Typography>
                        <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <Box sx={{ width: "80%" }}>
                                <Typography variant="body2" component="div" gutterBottom>
                                    <br />
                                    Cause: {props.note.extraFields.causeName}
                                </Typography>
                                <Typography variant="body2" component="div" gutterBottom>
                                    Amount: {props.note.extraFields.donationAmount}
                                </Typography>
                                <Typography variant="body2" component="div" gutterBottom>
                                    Proof: <a href={props.note.url} target="_blank" rel="noopener noreferrer"><strong>click to open</strong></a>
                                </Typography>
                            </Box>
                            <Box sx={{ width: "20%", marginRight: "2.75rem", marginTop: "1.125rem" }}>
                                <img src={PoolDonationImage}
                                    style={{ width: "4.375rem", height: "4.375rem" }}
                                    alt="profile-pic" width={"96"} height={"96"} />
                            </Box>
                        </Box>
                    </Grid>
                    <NoteExpiryGridPiece note={props.note} />
                    <Grid item xs={6} sm={6} sx={{ textAlign: "right", paddingRight: "1rem", padding: "0.5rem" }}>
                        <Typography variant="body2" component="div" gutterBottom sx={{ marginBottom: "0.0rem" }}>
                        </Typography>
                    </Grid>
                </Grid >
            </Box >
        </Box>
    );
}

function CycleEndedComponent(props) {

    return (
        <Box sx={{

        }}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
                <Grid container className='' spacing={0.5} sx={{
                    maxWidth: "21.55rem",
                    minWidth: "21.55rem",
                    width: "100.0%",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "0.5rem",
                    margin: "0.25rem",
                    backgroundColor: "rgba(221, 221, 221, 0.075)",
                    borderRadius: "0.25rem",
                    borderColor: "rgba(221, 221, 221, 0.25)",
                    border: "1px solid rgba(221, 221, 221, 0.35)"
                }}>
                    <Grid item xs={6} sm={6}>
                        <UsernameIconDisplay note={props.note} />
                    </Grid>
                    <DeleteNoteSectionComponent note={props.note} />
                    <LoveSectionComponent note={props.note} />
                    <Grid item xs={12} sm={12} sx={{ textAlign: "left", marginLeft: "1rem", marginTop: "0.45rem", marginBottom: "0.675rem" }}>
                        <Typography variant="body2" component="div" gutterBottom>
                            Cycle #{props.note.extraFields.cycleNumber} finished 🌱
                            <br /> <br />
                            {props.note.extraFields.cycleAmountGbp} queued for good causes
                        </Typography>
                    </Grid>
                    <NoteExpiryGridPiece note={props.note} />
                    <Grid item xs={6} sm={6} sx={{ textAlign: "right", paddingRight: "1rem", padding: "0.5rem" }}>
                        <Typography variant="body2" component="div" gutterBottom sx={{ marginBottom: "0.0rem" }}>
                        </Typography>
                    </Grid>
                </Grid >
            </Box>
        </Box>
    );
}

function CycleStartedComponent(props) {

    return (
        <Box sx={{

        }}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
                <Grid container className='' spacing={0.5} sx={{
                    maxWidth: "21.55rem",
                    minWidth: "21.55rem",
                    width: "100.0%",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "0.5rem",
                    margin: "0.25rem",
                    backgroundColor: "rgba(221, 221, 221, 0.075)",
                    borderRadius: "0.25rem",
                    borderColor: "rgba(221, 221, 221, 0.25)",
                    border: "1px solid rgba(221, 221, 221, 0.35)"
                }}>
                    <Grid item xs={6} sm={6}>
                        <UsernameIconDisplay note={props.note} />
                    </Grid>
                    <DeleteNoteSectionComponent note={props.note} />
                    <LoveSectionComponent note={props.note} />
                    <Grid item xs={12} sm={12} sx={{ textAlign: "left", marginLeft: "1rem", marginTop: "0.45rem", marginBottom: "0.675rem" }}>
                        <Typography variant="body2" component="div" gutterBottom>
                            Cycle #{props.note.extraFields.cycleNumber} started ⚡ {props.note.extraFields.cycleAmountGbp} allocated

                        </Typography>
                    </Grid>
                    <NoteExpiryGridPiece note={props.note} />
                    <Grid item xs={6} sm={6} sx={{ textAlign: "right", paddingRight: "1rem", padding: "0.5rem" }}>
                        <Typography variant="body2" component="div" gutterBottom sx={{ marginBottom: "0.0rem" }}>
                        </Typography>
                    </Grid>
                </Grid >
            </Box>
        </Box>
    );
}

function TextNoteComponent(props) {

    return (
        <Box sx={{
            width: "100%"
        }}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
                <Grid container className='' spacing={0.5} sx={{
                    maxWidth: "21.55rem",
                    minWidth: "21.55rem",
                    width: "100.0%",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "0.5rem",
                    margin: "0.25rem",
                    marginRight: 0,
                    marginLeft: 0,
                    backgroundColor: "rgba(221, 221, 221, 0.075)",
                    borderRadius: "0.25rem",
                    borderColor: "rgba(221, 221, 221, 0.25)",
                    border: "1px solid rgba(221, 221, 221, 0.35)",
                    whiteSpace: "pre-line",
                }}>
                    <Grid item xs={6} sm={6}>
                        <UsernameIconDisplay note={props.note} />
                    </Grid>
                    <DeleteNoteSectionComponent note={props.note} />
                    <LoveSectionComponent note={props.note} />
                    <Grid item xs={12} sm={12} sx={{ textAlign: "left", marginLeft: "1rem", marginTop: "0.45rem", marginBottom: "0.675rem", marginRight: "0.325rem" }}>
                        <Typography variant="body2" component="div" gutterBottom sx={{ lineHeight: "1.25rem" }}>
                            <ReactMarkdown linkTarget="_blank" 
                                components={{ p: "span" }}>
                                {"" + props.note.text}
                            </ReactMarkdown>
                        </Typography>
                    </Grid>
                    <NoteExpiryGridPiece note={props.note} neverExpires={props.neverExpires} />
                    <Grid item xs={6} sm={6} sx={{ textAlign: "right", paddingRight: "1rem", padding: "0.5rem" }}>
                        <Typography variant="body2" component="div" gutterBottom sx={{ marginBottom: "0.0rem" }}>
                        </Typography>
                    </Grid>
                </Grid >
            </Box>
        </Box>
    );
}


function NoteComponent(props) {

    const karmaContext = useKarmaPoolContext();

    // Mood tags are stored in an array of integers
    let moodTags = [];
    if (props.note.moodTags != null) {
        props.note.moodTags.forEach((moodTag) => {
            let convertedMoodTag = karmaContext.tagManager.getMoodTagById(moodTag);

            if (convertedMoodTag == null) {
                return;
            }

            moodTags.push(convertedMoodTag);
        });
    }

    if (props.note.noteType.includes("DONATION")) {
        return (
            <DonationNoteComponent note={props.note} moodTags={moodTags} neverExpires={props.neverExpires} />
        );
    }
    else if (props.note.noteType.includes("CYCLE_ENDED")) {
        return (
            <CycleEndedComponent note={props.note} moodTags={moodTags} neverExpires={props.neverExpires} />
        );
    }
    else if (props.note.noteType.includes("CYCLE_STARTED")) {
        return (
            <CycleStartedComponent note={props.note} moodTags={moodTags} neverExpires={props.neverExpires} />
        );
    }
    else if (props.note.noteType.includes("NEWS_ARTICLE")) {

    }
    else if (props.note.noteType.includes("IMAGE_NOTE")) {
        return (
            <ImageNoteComponent note={props.note} neverExpires={props.neverExpires} />
        );
    }
    else if (props.note.noteType.includes("FLASH_NOTE")) {
        return (
            <FlashNoteComponent note={props.note} neverExpires={props.neverExpires} />
        );
    }
    else if (props.note.url != null && props.note.url.includes("youtu") && props.note.noteType.includes("MUSIC")) {
        return (
            <YoutubeNoteComponent note={props.note} moodTags={moodTags} neverExpires={props.neverExpires} hideGenre={props.hideGenre} />
        );
    }
    else if (props.note.url != null && props.note.url.includes("spotify") && props.note.noteType.includes("MUSIC")) {
        if (props.note.isNewsletterNote) {
            return (
                <PlaylistFeatureNoteComponent note={props.note} moodTags={moodTags} neverExpires={props.neverExpires} hideGenre={props.hideGenre} />
            );
        }
        return (
            <SpotifyNoteComponent note={props.note} moodTags={moodTags} neverExpires={props.neverExpires} hideGenre={props.hideGenre} />
        );
    }
    else {
        return (
            <TextNoteComponent note={props.note} neverExpires={props.neverExpires} />
        );
    }
}

export default NoteComponent;